import React, { Component } from "react";

import { CommonService } from "../js_modules/CommonService";

import { SellToWebAdminDropdownComponent } from "../common/selltowebdropdown/SellToWebAdminDropdownComponent";
import { SellToWebAdminInputComponent } from "../common/selltowebinput/SellToWebAdminInputComponent";
import { SellToWebModalConfirmationComponent } from "../common/selltowebmodalconfirmation/SellToWebModalConfirmationComponent";
import { SellToWebModalDialogHeaderButtonComponent } from "../common/selltowebmodaldialog/SellToWebModalDialogHeaderButtonComponent";
import { SellToWebAdminToggleComponent } from "../common/selltowebcheckbox/SellToWebAdminToggleComponent";
import { SellToWebAdminModalDialogComponent } from "../common/selltowebmodaldialog/SellToWebAdminModalDialogComponent";

export class TenantSiteOfferMMRCalculationEditComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            maximumOfferAmountEnabled: false,
            maximumOdometerEnabled: false,
            minimumYearEnabled: false,
            minimumAverageGradeEnabled: false,
            gradeLikeNewConditionValueEnabled: false,
            gradeVeryGoodConditionValueEnabled: false,
            gradeAcceptableConditionValueEnabled: false,
            gradeMajorIssuesConditionValueEnabled: false,
            tireAdjustmentBelowThresholdAmountEnabled: false,
            tireAdjustmentAboveThresholdAmountEnabled: false,
            tireAdjustmentThresholdEnabled: false,
            windshieldAdjustmentBelowThresholdAmountEnabled: false,
            windshieldAdjustmentAboveThresholdAmountEnabled: false,
            windshieldAdjustmentThresholdEnabled: false,
            generalAdjustmentValueEnabled: false,
            accidentAdjustmentValueEnabled: false,
            wholesaleAdjustmentValueEnabled: false,
            odometerAdjustmentEnabledEnabled: false,
            forecastAdjustmentEnabledEnabled: false,
            isDefault: false,
            id: null,
            maximumOfferAmount: "",
            maximumOdometer: "",
            minimumYear: "",
            minimumAverageGrade: "",
            gradeLikeNewConditionValue: "",
            gradeVeryGoodConditionValue: "",
            gradeAcceptableConditionValue: "",
            gradeMajorIssuesConditionValue: "",
            tireAdjustmentBelowThresholdAmount: "",
            tireAdjustmentAboveThresholdAmount: "",
            tireAdjustmentThreshold: "",
            windshieldAdjustmentBelowThresholdAmount: "",
            windshieldAdjustmentAboveThresholdAmount: "",
            windshieldAdjustmentThreshold: "",
            accidentAdjustmentIsDollar: true,
            accidentAdjustmentValue: "",
            generalAdjustmentIsDollar: true,
            generalAdjustmentValue: "",
            wholesaleAdjustmentIsDollar: true,
            wholesaleAdjustmentValue: "",
            odometerAdjustmentEnabled: false,
            forecastAdjustmentEnabled: false,
            enableOfferCalculation: false,
            saveDisabled: true,
            enableYMM: false,
            vehicleMakes: null,
            makes: null,
            selectedMake: null,
            years: null,
            selectedYear: null,
            models: null,
            selectedModel: null,
            showUpdateConfirmation: false
        };

        this.onTextChange = this.onTextChange.bind(this);
        this.onCheckboxChange = this.onCheckboxChange.bind(this);
        this.onSaveClick = this.onSaveClick.bind(this);
        this.onSaveAsClick = this.onSaveAsClick.bind(this);
        this.onCancelClick = this.onCancelClick.bind(this);
        this.onDisableSave = this.onDisableSave.bind(this);
        this.onYearClick = this.onYearClick.bind(this);
        this.onMakeClick = this.onMakeClick.bind(this);
        this.onModelClick = this.onModelClick.bind(this);
        this.onConfirmationOkClick = this.onConfirmationOkClick.bind(this);
    }

    makesMultiple = [{ makeName: "Multiple" }];
    yearsMultiple = ["Multiple"];
    modelsMultiple = [{ modelName: "Multiple" }];
    makesDefault = [{ makeName: "Default" }];
    yearsDefault = ["Default"];
    modelsDefault = [{ modelName: "Default" }];

    componentDidMount() {
        try {
            this.getMMRVehicleMakes();
        }
        catch (error) {
            console.logError(error, "TenantSiteOfferMMRCalculationEditComponent", "componentDidMount");
        }
    }

    componentDidUpdate(prevProps, prevState) {
        try {
            if (!prevProps.showDialog && this.props.showDialog) {
                if (this.props.rowData?.length > 0) {
                    if (this.props.rowData.length > 1) {
                        this.setState({
                            years: this.yearsMultiple,
                            selectedYear: this.yearsMultiple[0],
                            makes: this.makesMultiple,
                            selectedMake: this.makesMultiple[0],
                            models: this.modelsMultiple,
                            selectedModel: this.modelsMultiple[0],
                            enableYMM: false
                        }, () => {
                            this.fillForm(this.props.rowData);
                        });
                    }
                    else if (this.props.rowData[0].isDefault) {
                        this.setState({
                            years: this.yearsDefault,
                            selectedYear: this.yearsDefault[0],
                            makes: this.makesDefault,
                            selectedMake: this.makesDefault[0],
                            models: this.modelsDefault,
                            selectedModel: this.modelsDefault[0],
                            enableYMM: false
                        }, () => {
                            this.fillForm(this.props.rowData[0]);
                        });
                    }
                    else {
                        let years = CommonService.getPreviousYearsByDate(25);
                        let makes = this.state.vehicleMakes;
                        let selectedYear = null, selectedMake = null;
                        let rowData = this.props.rowData[0];
                        if (rowData.year) {
                            selectedYear = CommonService.formatYear(rowData.year.toString());
                        }
                        if (rowData.make) {
                            selectedMake = makes.filter(make => make.makeName.toLowerCase().trim() === rowData.make.toLowerCase().trim())[0];
                        }

                        this.setState({
                            years: years,
                            selectedYear: selectedYear,
                            makes: makes,
                            selectedMake: selectedMake,
                            models: null,
                            selectedModel: null,
                            enableYMM: false
                        }, () => {
                            this.fillForm(this.props.rowData[0]);
                            if (rowData.make) {
                                this.getMMRVehicleModels();
                            }
                        });
                    }
                }
                else {
                    this.setState({
                        years: CommonService.getPreviousYearsByDate(25),
                        selectedYear: null,
                        makes: this.state.vehicleMakes,
                        selectedMake: null,
                        models: null,
                        selectedModel: null,
                        enableYMM: true
                    }, () => {
                        this.fillAddForm(this.props.defaultRow);
                    });
                }
            }
        }
        catch (error) {
            console.logError(error, "TenantSiteOfferMMRCalculationEditComponent", "componentDidUpdate");
        }
    }

    clearForm() {
        this.setState({
            selectedMake: null,
            selectedYear: null,
            models: null,
            selectedModel: null,
            isDefault: false,
            id: null,
            maximumOfferAmount: "",
            maximumOdometer: "",
            minimumYear: "",
            minimumAverageGrade: "",
            gradeLikeNewConditionValue: "",
            gradeVeryGoodConditionValue: "",
            gradeAcceptableConditionValue: "",
            gradeMajorIssuesConditionValue: "",
            tireAdjustmentBelowThresholdAmount: "",
            tireAdjustmentAboveThresholdAmount: "",
            tireAdjustmentThreshold: "",
            windshieldAdjustmentBelowThresholdAmount: "",
            windshieldAdjustmentAboveThresholdAmount: "",
            windshieldAdjustmentThreshold: "",
            generalAdjustmentIsDollar: true,
            generalAdjustmentValue: "",
            accidentAdjustmentIsDollar: true,
            accidentAdjustmentValue: "",
            wholesaleAdjustmentIsDollar: true,
            wholesaleAdjustmentValue: "",
            odometerAdjustmentEnabled: false,
            forecastAdjustmentEnabled: false,
            enableOfferCalculation: false,
            saveDisabled: true,
            enableYMM: false,
            maximumOfferAmountEnabled: false,
            maximumOdometerEnabled: false,
            minimumYearEnabled: false,
            minimumAverageGradeEnabled: false,
            gradeLikeNewConditionValueEnabled: false,
            gradeVeryGoodConditionValueEnabled: false,
            gradeAcceptableConditionValueEnabled: false,
            gradeMajorIssuesConditionValueEnabled: false,
            tireAdjustmentBelowThresholdAmountEnabled: false,
            tireAdjustmentAboveThresholdAmountEnabled: false,
            tireAdjustmentThresholdEnabled: false,
            windshieldAdjustmentBelowThresholdAmountEnabled: false,
            windshieldAdjustmentAboveThresholdAmountEnabled: false,
            windshieldAdjustmentThresholdEnabled: false,
            generalAdjustmentValueEnabled: false,
            accidentAdjustmentValueEnabled: false,
            wholesaleAdjustmentValueEnabled: false,
            odometerAdjustmentEnabledEnabled: false,
            forecastAdjustmentEnabledEnabled: false,
        }, this.onDisableSave);
    }

    fillForm(rowData) {
        this.setState({
            isDefault: rowData.isDefault,
            id: this.props.rowData.length > 1 ? null : rowData.id,
            maximumOfferAmount: this.props.rowData.length > 1 ? "" : CommonService.formatNumber(rowData.maximumOfferAmount),
            maximumOdometer: this.props.rowData.length > 1 ? "" : CommonService.formatNumber(rowData.maximumOdometer),
            minimumYear: this.props.rowData.length > 1 ? "" : rowData.minimumYear ?? 0,
            minimumAverageGrade: this.props.rowData.length > 1 ? "" : CommonService.formatNumber(rowData.minimumAverageGrade),
            gradeLikeNewConditionValue: this.props.rowData.length > 1 ? "" : CommonService.formatNumber(rowData.gradeLikeNewConditionValue),
            gradeVeryGoodConditionValue: this.props.rowData.length > 1 ? "" : CommonService.formatNumber(rowData.gradeVeryGoodConditionValue),
            gradeAcceptableConditionValue: this.props.rowData.length > 1 ? "" : CommonService.formatNumber(rowData.gradeAcceptableConditionValue),
            gradeMajorIssuesConditionValue: this.props.rowData.length > 1 ? "" : CommonService.formatNumber(rowData.gradeMajorIssuesConditionValue),
            tireAdjustmentBelowThresholdAmount: this.props.rowData.length > 1 ? "" : CommonService.formatNumber(rowData.tireAdjustmentBelowThresholdAmount),
            tireAdjustmentAboveThresholdAmount: this.props.rowData.length > 1 ? "" : CommonService.formatNumber(rowData.tireAdjustmentAboveThresholdAmount),
            tireAdjustmentThreshold: this.props.rowData.length > 1 ? "" : CommonService.formatNumber(rowData.tireAdjustmentThreshold),
            windshieldAdjustmentBelowThresholdAmount: this.props.rowData.length > 1 ? "" : CommonService.formatNumber(rowData.windshieldAdjustmentBelowThresholdAmount),
            windshieldAdjustmentAboveThresholdAmount: this.props.rowData.length > 1 ? "" : CommonService.formatNumber(rowData.windshieldAdjustmentAboveThresholdAmount),
            windshieldAdjustmentThreshold: this.props.rowData.length > 1 ? "" : CommonService.formatNumber(rowData.windshieldAdjustmentThreshold),
            accidentAdjustmentIsDollar: this.props.rowData.length > 1 ? true : rowData.accidentAdjustmentIsDollar,
            accidentAdjustmentValue: this.props.rowData.length > 1 ? "" : (rowData.accidentAdjustmentIsDollar ? CommonService.formatNumber(rowData.accidentAdjustmentValue) : CommonService.formatNumber_1(rowData.accidentAdjustmentValue * 100)),
            generalAdjustmentIsDollar: this.props.rowData.length > 1 ? true : rowData.generalAdjustmentIsDollar,
            generalAdjustmentValue: this.props.rowData.length > 1 ? "" : (rowData.generalAdjustmentIsDollar ? CommonService.formatNumber(rowData.generalAdjustmentValue) : CommonService.formatNumber_1(rowData.generalAdjustmentValue * 100)),
            wholesaleAdjustmentIsDollar: this.props.rowData.length > 1 ? true : rowData.wholesaleAdjustmentIsDollar,
            wholesaleAdjustmentValue: this.props.rowData.length > 1 ? "" : (rowData.wholesaleAdjustmentIsDollar ? CommonService.formatNumber(rowData.wholesaleAdjustmentValue) : CommonService.formatNumber_1(rowData.wholesaleAdjustmentValue * 100)),
            odometerAdjustmentEnabled: this.props.rowData.length > 1 ? false : rowData.odometerAdjustmentEnabled,
            forecastAdjustmentEnabled: this.props.rowData.length > 1 ? false : rowData.forecastAdjustmentEnabled,
            enableOfferCalculation: rowData.enableOfferCalculation,
            maximumOfferAmountEnabled: !rowData.isDefault && rowData.maximumOfferAmount === this.props.defaultRow.maximumOfferAmount,
            maximumOdometerEnabled: !rowData.isDefault && rowData.maximumOdometer === this.props.defaultRow.maximumOdometer,
            minimumYearEnabled: !rowData.isDefault && rowData.minimumYear === this.props.defaultRow.minimumYear,
            minimumAverageGradeEnabled: !rowData.isDefault && rowData.minimumAverageGrade === this.props.defaultRow.minimumAverageGrade,
            gradeLikeNewConditionValueEnabled: !rowData.isDefault && rowData.gradeLikeNewConditionValue === this.props.defaultRow.gradeLikeNewConditionValue,
            gradeVeryGoodConditionValueEnabled: !rowData.isDefault && rowData.gradeVeryGoodConditionValue === this.props.defaultRow.gradeVeryGoodConditionValue,
            gradeAcceptableConditionValueEnabled: !rowData.isDefault && rowData.gradeAcceptableConditionValue === this.props.defaultRow.gradeAcceptableConditionValue,
            gradeMajorIssuesConditionValueEnabled: !rowData.isDefault && rowData.gradeMajorIssuesConditionValue === this.props.defaultRow.gradeMajorIssuesConditionValue,
            tireAdjustmentBelowThresholdAmountEnabled: !rowData.isDefault && rowData.tireAdjustmentBelowThresholdAmount === this.props.defaultRow.tireAdjustmentBelowThresholdAmount,
            tireAdjustmentAboveThresholdAmountEnabled: !rowData.isDefault && rowData.tireAdjustmentAboveThresholdAmount === this.props.defaultRow.tireAdjustmentAboveThresholdAmount,
            tireAdjustmentThresholdEnabled: !rowData.isDefault && rowData.tireAdjustmentThreshold === this.props.defaultRow.tireAdjustmentThreshold,
            windshieldAdjustmentBelowThresholdAmountEnabled: !rowData.isDefault && rowData.windshieldAdjustmentBelowThresholdAmount === this.props.defaultRow.windshieldAdjustmentBelowThresholdAmount,
            windshieldAdjustmentAboveThresholdAmountEnabled: !rowData.isDefault && rowData.windshieldAdjustmentAboveThresholdAmount === this.props.defaultRow.windshieldAdjustmentAboveThresholdAmount,
            windshieldAdjustmentThresholdEnabled: !rowData.isDefault && rowData.windshieldAdjustmentThreshold === this.props.defaultRow.windshieldAdjustmentThreshold,
            generalAdjustmentValueEnabled: !rowData.isDefault && rowData.generalAdjustmentValue === this.props.defaultRow.generalAdjustmentValue,
            accidentAdjustmentValueEnabled: !rowData.isDefault && rowData.accidentAdjustmentValue === this.props.defaultRow.accidentAdjustmentValue,
            wholesaleAdjustmentValueEnabled: !rowData.isDefault && rowData.wholesaleAdjustmentValue === this.props.defaultRow.wholesaleAdjustmentValue,
            odometerAdjustmentEnabledEnabled: !rowData.isDefault && rowData.odometerAdjustmentEnabled === this.props.defaultRow.odometerAdjustmentEnabled,
            forecastAdjustmentEnabledEnabled: !rowData.isDefault && rowData.forecastAdjustmentEnabled === this.props.defaultRow.forecastAdjustmentEnabled,
        }, this.onDisableSave);
    }

    fillAddForm(defaultRow) {
        this.setState({
            isDefault: false,
            id: null,
            maximumOfferAmount: CommonService.formatNumber(defaultRow.maximumOfferAmount),
            maximumOdometer: CommonService.formatNumber(defaultRow.maximumOdometer),
            minimumYear: defaultRow.minimumYear ?? 0,
            minimumAverageGrade: CommonService.formatNumber(defaultRow.minimumAverageGrade),
            gradeLikeNewConditionValue: CommonService.formatNumber(defaultRow.gradeLikeNewConditionValue),
            gradeVeryGoodConditionValue: CommonService.formatNumber(defaultRow.gradeVeryGoodConditionValue),
            gradeAcceptableConditionValue: CommonService.formatNumber(defaultRow.gradeAcceptableConditionValue),
            gradeMajorIssuesConditionValue: CommonService.formatNumber(defaultRow.gradeMajorIssuesConditionValue),
            tireAdjustmentBelowThresholdAmount: CommonService.formatNumber(defaultRow.tireAdjustmentBelowThresholdAmount),
            tireAdjustmentAboveThresholdAmount: CommonService.formatNumber(defaultRow.tireAdjustmentAboveThresholdAmount),
            tireAdjustmentThreshold: CommonService.formatNumber(defaultRow.tireAdjustmentThreshold),
            windshieldAdjustmentBelowThresholdAmount: CommonService.formatNumber(defaultRow.windshieldAdjustmentBelowThresholdAmount),
            windshieldAdjustmentAboveThresholdAmount: CommonService.formatNumber(defaultRow.windshieldAdjustmentAboveThresholdAmount),
            windshieldAdjustmentThreshold: CommonService.formatNumber(defaultRow.windshieldAdjustmentThreshold),
            accidentAdjustmentIsDollar: defaultRow.accidentAdjustmentIsDollar,
            accidentAdjustmentValue: (defaultRow.accidentAdjustmentIsDollar ? CommonService.formatNumber(defaultRow.accidentAdjustmentValue) : CommonService.formatNumber_1(defaultRow.accidentAdjustmentValue * 100)),
            generalAdjustmentIsDollar: defaultRow.generalAdjustmentIsDollar,
            generalAdjustmentValue: (defaultRow.generalAdjustmentIsDollar ? CommonService.formatNumber(defaultRow.generalAdjustmentValue) : CommonService.formatNumber_1(defaultRow.generalAdjustmentValue * 100)),
            wholesaleAdjustmentIsDollar: defaultRow.wholesaleAdjustmentIsDollar,
            wholesaleAdjustmentValue: (defaultRow.wholesaleAdjustmentIsDollar ? CommonService.formatNumber(defaultRow.wholesaleAdjustmentValue) : CommonService.formatNumber_1(defaultRow.wholesaleAdjustmentValue * 100)),
            odometerAdjustmentEnabled: defaultRow.odometerAdjustmentEnabled,
            forecastAdjustmentEnabled: defaultRow.forecastAdjustmentEnabled,
            enableOfferCalculation: defaultRow.enableOfferCalculation,
            maximumOfferAmountEnabled: true,
            maximumOdometerEnabled: true,
            minimumYearEnabled: true,
            minimumAverageGradeEnabled: true,
            gradeLikeNewConditionValueEnabled: true,
            gradeVeryGoodConditionValueEnabled: true,
            gradeAcceptableConditionValueEnabled: true,
            gradeMajorIssuesConditionValueEnabled: true,
            tireAdjustmentBelowThresholdAmountEnabled: true,
            tireAdjustmentAboveThresholdAmountEnabled: true,
            tireAdjustmentThresholdEnabled: true,
            windshieldAdjustmentBelowThresholdAmountEnabled: true,
            windshieldAdjustmentAboveThresholdAmountEnabled: true,
            windshieldAdjustmentThresholdEnabled: true,
            generalAdjustmentValueEnabled: true,
            accidentAdjustmentValueEnabled: true,
            wholesaleAdjustmentValueEnabled: true,
            odometerAdjustmentEnabledEnabled: true,
            forecastAdjustmentEnabledEnabled: true
        }, this.onDisableSave);
    }

    getMMRVehicleMakes() {
        try {
            this.props.applicationInsights.trackTrace({ message: "TenantSiteOfferMMRCalculationEditComponent/getMMRVehicleMakes", properties: { logon: this.props.logon } });
            fetch("/TenantSite/GetMMRVehicleMakes", {
                method: "GET",
                headers: {
                    "Content-Type": "application/json; charset=utf-8;"
                },
                credentials: "same-origin"
            })
                .then(response => { if (response.ok) { return response.json() } else { throw response; } })
                .then(parsedResponse => {
                    this.setState({
                        vehicleMakes: parsedResponse.table,
                    });
                })
                .catch(notOKResponse => {
                    if (notOKResponse.status === 500) {
                        notOKResponse.json()
                            .then(parsedError => {
                                this.props.applicationInsights.trackException({ exception: parsedError, properties: { method: "/TenantSite/GetMMRVehicleMakes", ...parsedError, logon: this.props.logon } });
                                console.logError(parsedError, "TenantSiteOfferMMRCalculationEditComponent", "getMMRVehicleMakes");
                                this.props.onShowAlert("danger", parsedError);
                            })
                            .catch(jsonParseError => {
                                console.logError(jsonParseError, "TenantSiteOfferMMRCalculationEditComponent", "getMMRVehicleMakes");
                            });
                    }
                });
        }
        catch (error) {
            console.logError(error, "TenantSiteOfferMMRCalculationEditComponent", "getMMRVehicleMakes");
        }
    }

    getMMRVehicleModels() {
        try {
            let inputData = {
                year: this.state.selectedYear ? CommonService.formatYear(this.state.selectedYear) : "",
                makeName: this.state.selectedMake.makeName,
            };

            this.props.applicationInsights.trackTrace({ message: "TenantSiteOfferMMRCalculationEditComponent/getMMRVehicleModels", properties: { ...inputData, logon: this.props.logon } });
            fetch("/TenantSite/GetMMRVehicleModels", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json; charset=utf-8;"
                },
                body: JSON.stringify(inputData),
                credentials: "same-origin"
            })
                .then(response => { if (response.ok) { return response.json() } else { throw response; } })
                .then(parsedResponse => {
                    let selectedModel = null;
                    if (this.props.rowData?.length === 1) {
                        let rowData = this.props.rowData[0];
                        if (rowData.model) {
                            selectedModel = parsedResponse.table.filter(model => model.modelName.toString() === rowData.model.toString())[0];
                        }
                    }
                    this.setState({
                        models: parsedResponse.table,
                        selectedModel: selectedModel,
                    });
                })
                .catch(notOKResponse => {
                    if (notOKResponse.status === 500) {
                        notOKResponse.json()
                            .then(parsedError => {
                                this.props.applicationInsights.trackException({ exception: parsedError, properties: { method: "/TenantSite/GetMMRVehicleModels", ...inputData, ...parsedError, logon: this.props.logon } });
                                console.logError(parsedError, "TenantSiteOfferMMRCalculationEditComponent", "getMMRVehicleModels");
                                this.props.onShowAlert("danger", parsedError);
                            })
                            .catch(jsonParseError => {
                                console.logError(jsonParseError, "TenantSiteOfferMMRCalculationEditComponent", "getMMRVehicleModels");
                            });
                    }
                });
        }
        catch (error) {
            console.logError(error, "TenantSiteOfferMMRCalculationEditComponent", "getMMRVehicleModels");
        }
    }

    onTextChange(id, value) {
        try {
            this.setState({ [id]: value }, this.onDisableSave);
        }
        catch (error) {
            console.logError(error, "TenantSiteOfferMMRCalculationEditComponent", "onTextChange", id);
        }
    }

    onCheckboxChange(id, value) {
        try {
            this.setState({ [id]: value }, this.onDisableSave);
        }
        catch (error) {
            console.logError(error, "TenantSiteOfferMMRCalculationEditComponent", "onCheckboxChange", id);
        }
    }

    getData() {
        let changedFields = {};

        if (this.state.maximumOfferAmountEnabled || this.state.maximumOfferAmount !== "") {
            let maximumOfferAmount = parseFloat(this.state.maximumOfferAmount.replace(/,/g, ''));
            changedFields.maximumOfferAmount = this.state.maximumOfferAmountEnabled || this.props.defaultRow.maximumOfferAmount === maximumOfferAmount ? null : maximumOfferAmount;
        }

        if (this.state.maximumOdometerEnabled || this.state.maximumOdometer !== "") {
            let maximumOdometer = parseInt(this.state.maximumOdometer.replace(/,/g, ''));
            changedFields.maximumOdometer = this.state.maximumOdometerEnabled || this.props.defaultRow.maximumOdometer === maximumOdometer ? null : maximumOdometer;
        }

        if (this.state.minimumYearEnabled || this.state.minimumYear !== "") {
            let minimumYear = parseInt(this.state.minimumYear);
            changedFields.minimumYear = this.state.minimumYearEnabled || this.props.defaultRow.minimumYear === minimumYear ? null : minimumYear;
        }

        if (this.state.minimumAverageGradeEnabled || this.state.minimumAverageGrade !== "") {
            let minimumAverageGrade = parseFloat(this.state.minimumAverageGrade.replace(/,/g, ''));
            changedFields.minimumAverageGrade = this.state.minimumAverageGradeEnabled || this.props.defaultRow.minimumAverageGrade === minimumAverageGrade ? null : minimumAverageGrade;
        }

        if (this.state.gradeLikeNewConditionValueEnabled || this.state.gradeLikeNewConditionValue !== "") {
            let gradeLikeNewConditionValue = parseFloat(this.state.gradeLikeNewConditionValue.replace(/,/g, ''));
            changedFields.gradeLikeNewConditionValue = this.state.gradeLikeNewConditionValueEnabled || this.props.defaultRow.gradeLikeNewConditionValue === gradeLikeNewConditionValue ? null : gradeLikeNewConditionValue;
        }

        if (this.state.gradeVeryGoodConditionValueEnabled || this.state.gradeVeryGoodConditionValue !== "") {
            let gradeVeryGoodConditionValue = parseFloat(this.state.gradeVeryGoodConditionValue.replace(/,/g, ''));
            changedFields.gradeVeryGoodConditionValue = this.state.gradeVeryGoodConditionValueEnabled || this.props.defaultRow.gradeVeryGoodConditionValue === gradeVeryGoodConditionValue ? null : gradeVeryGoodConditionValue;
        }

        if (this.state.gradeAcceptableConditionValueEnabled || this.state.gradeAcceptableConditionValue !== "") {
            let gradeAcceptableConditionValue = parseFloat(this.state.gradeAcceptableConditionValue.replace(/,/g, ''));
            changedFields.gradeAcceptableConditionValue = this.state.gradeAcceptableConditionValueEnabled || this.props.defaultRow.gradeAcceptableConditionValue === gradeAcceptableConditionValue ? null : gradeAcceptableConditionValue;
        }

        if (this.state.gradeMajorIssuesConditionValueEnabled || this.state.gradeMajorIssuesConditionValue !== "") {
            let gradeMajorIssuesConditionValue = parseFloat(this.state.gradeMajorIssuesConditionValue.replace(/,/g, ''));
            changedFields.gradeMajorIssuesConditionValue = this.state.gradeMajorIssuesConditionValueEnabled || this.props.defaultRow.gradeMajorIssuesConditionValue === gradeMajorIssuesConditionValue ? null : gradeMajorIssuesConditionValue;
        }

        if (this.state.tireAdjustmentBelowThresholdAmountEnabled || this.state.tireAdjustmentBelowThresholdAmount !== "") {
            let tireAdjustmentBelowThresholdAmount = parseFloat(this.state.tireAdjustmentBelowThresholdAmount.replace(/,/g, ''));
            changedFields.tireAdjustmentBelowThresholdAmount = this.state.tireAdjustmentBelowThresholdAmountEnabled || this.props.defaultRow.tireAdjustmentBelowThresholdAmount === tireAdjustmentBelowThresholdAmount ? null : tireAdjustmentBelowThresholdAmount;
        }

        if (this.state.tireAdjustmentAboveThresholdAmountEnabled || this.state.tireAdjustmentAboveThresholdAmount !== "") {
            let tireAdjustmentAboveThresholdAmount = parseFloat(this.state.tireAdjustmentAboveThresholdAmount.replace(/,/g, ''));
            changedFields.tireAdjustmentAboveThresholdAmount = this.state.tireAdjustmentAboveThresholdAmountEnabled || this.props.defaultRow.tireAdjustmentAboveThresholdAmount === tireAdjustmentAboveThresholdAmount ? null : tireAdjustmentAboveThresholdAmount;
        }

        if (this.state.tireAdjustmentThresholdEnabled || this.state.tireAdjustmentThreshold !== "") {
            let tireAdjustmentThreshold = parseFloat(this.state.tireAdjustmentThreshold.replace(/,/g, ''));
            changedFields.tireAdjustmentThreshold = this.state.tireAdjustmentThresholdEnabled || this.props.defaultRow.tireAdjustmentThreshold === tireAdjustmentThreshold ? null : tireAdjustmentThreshold;
        }

        if (this.state.windshieldAdjustmentBelowThresholdAmountEnabled || this.state.windshieldAdjustmentBelowThresholdAmount !== "") {
            let windshieldAdjustmentBelowThresholdAmount = parseFloat(this.state.windshieldAdjustmentBelowThresholdAmount.replace(/,/g, ''));
            changedFields.windshieldAdjustmentBelowThresholdAmount = this.state.windshieldAdjustmentBelowThresholdAmountEnabled || this.props.defaultRow.windshieldAdjustmentBelowThresholdAmount === windshieldAdjustmentBelowThresholdAmount ? null : windshieldAdjustmentBelowThresholdAmount;
        }

        if (this.state.windshieldAdjustmentAboveThresholdAmountEnabled || this.state.windshieldAdjustmentAboveThresholdAmount !== "") {
            let windshieldAdjustmentAboveThresholdAmount = parseFloat(this.state.windshieldAdjustmentAboveThresholdAmount.replace(/,/g, ''));
            changedFields.windshieldAdjustmentAboveThresholdAmount = this.state.windshieldAdjustmentAboveThresholdAmountEnabled || this.props.defaultRow.windshieldAdjustmentAboveThresholdAmount === windshieldAdjustmentAboveThresholdAmount ? null : windshieldAdjustmentAboveThresholdAmount;
        }

        if (this.state.windshieldAdjustmentThresholdEnabled || this.state.windshieldAdjustmentThreshold !== "") {
            let windshieldAdjustmentThreshold = parseFloat(this.state.windshieldAdjustmentThreshold.replace(/,/g, ''));
            changedFields.windshieldAdjustmentThreshold = this.state.windshieldAdjustmentThresholdEnabled || this.props.defaultRow.windshieldAdjustmentThreshold === windshieldAdjustmentThreshold ? null : windshieldAdjustmentThreshold;
        }

        if (this.state.generalAdjustmentValueEnabled || this.state.generalAdjustmentValue !== "") {
            changedFields.generalAdjustmentIsDollar = this.state.generalAdjustmentValueEnabled ? null : this.state.generalAdjustmentIsDollar;
            let generalAdjustmentValue = parseFloat(this.state.generalAdjustmentValue.replace(/,/g, ''));
            generalAdjustmentValue = this.state.generalAdjustmentIsDollar ? generalAdjustmentValue : generalAdjustmentValue / 100;
            changedFields.generalAdjustmentValue = this.state.generalAdjustmentValueEnabled || this.state.generalAdjustmentValue === generalAdjustmentValue ? null : generalAdjustmentValue;
        }

        if (this.state.accidentAdjustmentValueEnabled || this.state.accidentAdjustmentValue !== "") {
            changedFields.accidentAdjustmentIsDollar = this.state.accidentAdjustmentValueEnabled ? null : this.state.accidentAdjustmentIsDollar;
            let accidentAdjustmentValue = parseFloat(this.state.accidentAdjustmentValue.replace(/,/g, ''));
            accidentAdjustmentValue = this.state.accidentAdjustmentIsDollar ? accidentAdjustmentValue : accidentAdjustmentValue / 100;
            changedFields.accidentAdjustmentValue = this.state.accidentAdjustmentValueEnabled || this.state.accidentAdjustmentValue === accidentAdjustmentValue ? null : accidentAdjustmentValue;
        }

        if (this.state.wholesaleAdjustmentValueEnabled || this.state.wholesaleAdjustmentValue !== "") {
            changedFields.wholesaleAdjustmentIsDollar = this.state.wholesaleAdjustmentValueEnabled ? null : this.state.wholesaleAdjustmentIsDollar;
            let wholesaleAdjustmentValue = parseFloat(this.state.wholesaleAdjustmentValue.replace(/,/g, ''));
            wholesaleAdjustmentValue = this.state.wholesaleAdjustmentIsDollar ? wholesaleAdjustmentValue : wholesaleAdjustmentValue / 100;
            changedFields.wholesaleAdjustmentValue = this.state.wholesaleAdjustmentValueEnabled || this.state.wholesaleAdjustmentValue === wholesaleAdjustmentValue ? null : wholesaleAdjustmentValue;
        }

        changedFields.odometerAdjustmentEnabled = this.state.odometerAdjustmentEnabledEnabled || this.props.defaultRow.odometerAdjustmentEnabled === this.state.odometerAdjustmentEnabled ? null : this.state.odometerAdjustmentEnabled;
        changedFields.forecastAdjustmentEnabled = this.state.forecastAdjustmentEnabledEnabled || this.props.defaultRow.forecastAdjustmentEnabled === this.state.forecastAdjustmentEnabled ? null : this.state.forecastAdjustmentEnabled;

        changedFields.enableOfferCalculation = this.state.enableOfferCalculation;

        return changedFields;
    };

    onSaveClick() {
        try {
            this.setState({
                saveDisabled: true
            });

            if (this.state.id) {
                this.saveSiteCalcConfig(this.state.id);
            }
            else if (this.props.rowData?.length > 1) {
                this.saveSiteCalcConfig(null);
            }
            else {
                let inputData = {
                    siteGuid: this.props.selectedSite.guid,
                    year: (this.state.selectedYear && this.state.selectedYear !== "Default" && this.state.selectedYear !== "Multiple" && this.state.selectedYear !== "All") ? parseInt(CommonService.formatYear(this.state.selectedYear)) : null,
                    make: (this.state.selectedMake && this.state.selectedMake.makeName !== "Default" && this.state.selectedMake.makeName !== "Multiple") ? this.state.selectedMake.makeName : null,
                    model: (this.state.selectedModel && this.state.selectedModel.modelName !== "Default" && this.state.selectedModel.modelName !== "Multiple") ? this.state.selectedModel.modelName : null,
                };
                this.props.applicationInsights.trackTrace({ message: "TenantSiteOfferMMRCalculationEditComponent/onSaveClick", properties: { ...inputData, logon: this.props.logon } });
                fetch("/TenantSite/GetMMRSiteCalcConfig", {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json; charset=utf-8;"
                    },
                    body: JSON.stringify(inputData),
                    credentials: "same-origin"
                })
                    .then(response => { if (response.ok) { return response.json() } else { throw response; } })
                    .then(parsedResponse => {
                        if (parsedResponse.table
                            && parsedResponse.table[0].year === inputData.year
                            && parsedResponse.table[0].make === inputData.make
                            && parsedResponse.table[0].model === inputData.model) {
                            // Show Confirmation
                            this.setState({
                                id: parsedResponse.table[0].id,
                                showUpdateConfirmation: true
                            });
                        }
                        else {
                            this.saveSiteCalcConfig(null);
                        }
                    })
                    .catch(notOKResponse => {
                        if (notOKResponse.status === 500) {
                            notOKResponse.json()
                                .then(parsedError => {
                                    this.props.applicationInsights.trackException({ exception: parsedError, properties: { method: "/TenantSite/GetMMRSiteCalcConfig", ...inputData, ...parsedError, logon: this.props.logon } });
                                    console.logError(parsedError, "TenantSiteOfferMMRCalculationEditComponent", "onSaveClick");
                                    this.props.onShowAlert("danger", parsedError);
                                })
                                .catch(jsonParseError => {
                                    console.logError(jsonParseError, "TenantSiteOfferMMRCalculationEditComponent", "onSaveClick");
                                });
                        }
                    });
            }
        }
        catch (error) {
            console.logError(error, "TenantSiteOfferMMRCalculationEditComponent", "onSaveClick");
        }
    }

    saveSiteCalcConfig(id) {
        try {
            let maximumOfferAmount = parseFloat(this.state.maximumOfferAmount.replace(/,/g, ''));
            let maximumOdometer = parseInt(this.state.maximumOdometer.replace(/,/g, ''));
            let minimumAverageGrade = parseFloat(this.state.minimumAverageGrade.replace(/,/g, ''));
            let minimumYear = parseInt(this.state.minimumYear);
            let gradeLikeNewConditionValue = parseFloat(this.state.gradeLikeNewConditionValue.replace(/,/g, ''));
            let gradeVeryGoodConditionValue = parseFloat(this.state.gradeVeryGoodConditionValue.replace(/,/g, ''));
            let gradeAcceptableConditionValue = parseFloat(this.state.gradeAcceptableConditionValue.replace(/,/g, ''));
            let gradeMajorIssuesConditionValue = parseFloat(this.state.gradeMajorIssuesConditionValue.replace(/,/g, ''));
            let tireAdjustmentBelowThresholdAmount = parseFloat(this.state.tireAdjustmentBelowThresholdAmount.replace(/,/g, ''));
            let tireAdjustmentAboveThresholdAmount = parseFloat(this.state.tireAdjustmentAboveThresholdAmount.replace(/,/g, ''));
            let tireAdjustmentThreshold = parseFloat(this.state.tireAdjustmentThreshold.replace(/,/g, ''));
            let windshieldAdjustmentBelowThresholdAmount = parseFloat(this.state.windshieldAdjustmentBelowThresholdAmount.replace(/,/g, ''));
            let windshieldAdjustmentAboveThresholdAmount = parseFloat(this.state.windshieldAdjustmentAboveThresholdAmount.replace(/,/g, ''));
            let windshieldAdjustmentThreshold = parseFloat(this.state.windshieldAdjustmentThreshold.replace(/,/g, ''));
            let accidentAdjustmentValue = parseFloat(this.state.accidentAdjustmentValue.replace(/,/g, ''));
            accidentAdjustmentValue = this.state.accidentAdjustmentIsDollar ? accidentAdjustmentValue : accidentAdjustmentValue / 100;
            let generalAdjustmentValue = parseFloat(this.state.generalAdjustmentValue.replace(/,/g, ''));
            generalAdjustmentValue = this.state.generalAdjustmentIsDollar ? generalAdjustmentValue : generalAdjustmentValue / 100;
            let wholesaleAdjustmentValue = parseFloat(this.state.wholesaleAdjustmentValue.replace(/,/g, ''));
            wholesaleAdjustmentValue = this.state.wholesaleAdjustmentIsDollar ? wholesaleAdjustmentValue : wholesaleAdjustmentValue / 100;

            let inputData = {
                siteGuid: this.props.selectedSite.guid,
                isDefault: this.state.isDefault,
                year: (this.state.selectedYear && this.state.selectedYear !== "Default" && this.state.selectedYear !== "Multiple" && this.state.selectedYear !== "All") ? parseInt(CommonService.formatYear(this.state.selectedYear)) : null,
                make: (this.state.selectedMake && this.state.selectedMake.makeName !== "Default" && this.state.selectedMake.makeName !== "Multiple") ? this.state.selectedMake.makeName : null,
                model: (this.state.selectedModel && this.state.selectedModel.modelName !== "Default" && this.state.selectedModel.modelName !== "Multiple") ? this.state.selectedModel.modelName : null,
                trim: null,
                id: this.state.id,
                maximumOfferAmount: this.state.maximumOfferAmountEnabled ? null : (!this.state.isDefault && maximumOfferAmount === this.props.defaultRow.maximumOfferAmount ? null : maximumOfferAmount),
                maximumOdometer: this.state.maximumOdometerEnabled ? null : (!this.state.isDefault && maximumOdometer === this.props.defaultRow.maximumOdometer ? null : maximumOdometer),
                minimumYear: this.state.minimumYearEnabled ? null : (!this.state.isDefault && minimumYear === this.props.defaultRow.minimumYear ? null : minimumYear),
                minimumAverageGrade: this.state.minimumAverageGradeEnabled ? null : (!this.state.isDefault && minimumAverageGrade === this.props.defaultRow.minimumAverageGrade ? null : minimumAverageGrade),
                gradeLikeNewConditionValue: this.state.gradeLikeNewConditionValueEnabled ? null : (!this.state.isDefault && gradeLikeNewConditionValue === this.props.defaultRow.gradeLikeNewConditionValue ? null : gradeLikeNewConditionValue),
                gradeVeryGoodConditionValue: this.state.gradeVeryGoodConditionValueEnabled ? null : (!this.state.isDefault && gradeVeryGoodConditionValue === this.props.defaultRow.gradeVeryGoodConditionValue ? null : gradeVeryGoodConditionValue),
                gradeAcceptableConditionValue: this.state.gradeAcceptableConditionValueEnabled ? null : (!this.state.isDefault && gradeAcceptableConditionValue === this.props.defaultRow.gradeAcceptableConditionValue ? null : gradeAcceptableConditionValue),
                gradeMajorIssuesConditionValue: this.state.gradeMajorIssuesConditionValueEnabled ? null : (!this.state.isDefault && gradeMajorIssuesConditionValue === this.props.defaultRow.gradeMajorIssuesConditionValue ? null : gradeMajorIssuesConditionValue),
                tireAdjustmentBelowThresholdAmount: this.state.tireAdjustmentBelowThresholdAmountEnabled ? null : (!this.state.isDefault && tireAdjustmentBelowThresholdAmount === this.props.defaultRow.tireAdjustmentBelowThresholdAmount ? null : tireAdjustmentBelowThresholdAmount),
                tireAdjustmentAboveThresholdAmount: this.state.tireAdjustmentAboveThresholdAmountEnabled ? null : (!this.state.isDefault && tireAdjustmentAboveThresholdAmount === this.props.defaultRow.tireAdjustmentAboveThresholdAmount ? null : tireAdjustmentAboveThresholdAmount),
                tireAdjustmentThreshold: this.state.tireAdjustmentThresholdEnabled ? null : (!this.state.isDefault && tireAdjustmentThreshold === this.props.defaultRow.tireAdjustmentThreshold ? null : tireAdjustmentThreshold),
                windshieldAdjustmentBelowThresholdAmount: this.state.windshieldAdjustmentBelowThresholdAmountEnabled ? null : (!this.state.isDefault && windshieldAdjustmentBelowThresholdAmount === this.props.defaultRow.windshieldAdjustmentBelowThresholdAmount ? null : windshieldAdjustmentBelowThresholdAmount),
                windshieldAdjustmentAboveThresholdAmount: this.state.windshieldAdjustmentAboveThresholdAmountEnabled ? null : (!this.state.isDefault && windshieldAdjustmentAboveThresholdAmount === this.props.defaultRow.windshieldAdjustmentAboveThresholdAmount ? null : windshieldAdjustmentAboveThresholdAmount),
                windshieldAdjustmentThreshold: this.state.windshieldAdjustmentThresholdEnabled ? null : (!this.state.isDefault && windshieldAdjustmentThreshold === this.props.defaultRow.windshieldAdjustmentThreshold ? null : windshieldAdjustmentThreshold),
                generalAdjustmentIsDollar: this.state.generalAdjustmentValueEnabled ? null : this.state.generalAdjustmentIsDollar,
                generalAdjustmentValue: this.state.generalAdjustmentValueEnabled ? null : (!this.state.isDefault && generalAdjustmentValue === this.props.defaultRow.generalAdjustmentValue ? null : generalAdjustmentValue),
                accidentAdjustmentIsDollar: this.state.accidentAdjustmentValueEnabled ? null : this.state.accidentAdjustmentIsDollar,
                accidentAdjustmentValue: this.state.accidentAdjustmentValueEnabled ? null : (!this.state.isDefault && accidentAdjustmentValue === this.props.defaultRow.accidentAdjustmentValue ? null : accidentAdjustmentValue),
                wholesaleAdjustmentIsDollar: this.state.wholesaleAdjustmentValueEnabled ? null : this.state.wholesaleAdjustmentIsDollar,
                wholesaleAdjustmentValue: this.state.wholesaleAdjustmentValueEnabled ? null : (!this.state.isDefault && wholesaleAdjustmentValue === this.props.defaultRow.wholesaleAdjustmentValue ? null : wholesaleAdjustmentValue),
                odometerAdjustmentEnabled: this.state.odometerAdjustmentEnabledEnabled ? null : this.state.odometerAdjustmentEnabled,
                forecastAdjustmentEnabled: this.state.forecastAdjustmentEnabledEnabled ? null : this.state.forecastAdjustmentEnabled,
                enableOfferCalculation: this.state.enableOfferCalculation,
                isDelete: false,
                siteName: this.props.selectedSite.siteName,
                tenantShortName: this.props.selectedTenant.shortName
            };
            let saveApiUrl = "/TenantSite/SaveSiteCalculationConfigMMR";
            if (this.props.rowData?.length > 1) {
                inputData = {
                    id: this.props.rowData.map(row => row.id),
                    data: this.getData(),
                    siteName: this.props.selectedSite.siteName,
                    tenantShortName: this.props.selectedTenant.shortName
                };
                saveApiUrl = "/TenantSite/SaveSiteCalculationConfigMMRBulk";
            }
            this.props.applicationInsights.trackTrace({ message: "TenantSiteOfferMMRCalculationEditComponent/saveSiteCalcConfig", properties: { ...inputData, logon: this.props.logon } });
            fetch(saveApiUrl, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json; charset=utf-8;"
                },
                body: JSON.stringify(inputData),
                credentials: "same-origin"
            })
                .then(response => { if (response.ok) { return response.json(); } else { throw response; } })
                .then(parsedResponse => {
                    this.clearForm();
                    this.props.onSaveClick();
                })
                .catch(notOKResponse => {
                    if (notOKResponse.status === 500) {
                        notOKResponse.json()
                            .then(parsedError => {
                                this.props.applicationInsights.trackException({ exception: parsedError, properties: { method: saveApiUrl, ...inputData, ...parsedError, logon: this.props.logon } });
                                console.logError(parsedError, "TenantSiteOfferMMRCalculationEditComponent", "saveSiteCalcConfig");
                                this.props.onShowAlert("danger", parsedError);
                            })
                            .catch(jsonParseError => {
                                console.logError(jsonParseError, "TenantSiteOfferMMRCalculationEditComponent", "saveSiteCalcConfig");
                            });
                    }
                });
        }
        catch (error) {
            console.logError(error, "TenantSiteOfferMMRCalculationEditComponent", "onSaveClick");
        }

    }

    onSaveAsClick() {
        try {
            let years = CommonService.getPreviousYearsByDate(25);
            let makes = this.state.vehicleMakes;
            this.setState({
                enableYMM: true,
                id: null,
                isDefault: false,
                makes: makes,
                years: years,
                models: null,
                selectedMake: null,
                selectedYear: null,
                selectedModel: null
            });
        }
        catch (error) {
            console.logError(error, "TenantSiteOfferMMRCalculationEditComponent", "onSaveAsClick");
        }
    }

    onCancelClick() {
        try {
            this.clearForm();
            this.onSaveAsClick();
            this.props.onCancelClick();
        }
        catch (error) {
            console.logError(error, "TenantSiteOfferMMRCalculationEditComponent", "onCancelClick");
        }
    }

    onDisableSave() {
        try {
            let disabled = !(this.props.rowData && this.props.rowData.length > 1)
                && ((this.state.maximumOfferAmount === null || this.state.maximumOfferAmount === "")
                    || (this.state.maximumOdometer === null || this.state.maximumOdometer === "")
                    || (this.state.minimumYear === null || this.state.minimumYear === "")
                    || (this.state.minimumAverageGrade === null || this.state.minimumAverageGrade === "")
                    || (this.state.gradeLikeNewConditionValue === null || this.state.gradeLikeNewConditionValue === "")
                    || (this.state.gradeVeryGoodConditionValue === null || this.state.gradeVeryGoodConditionValue === "")
                    || (this.state.gradeAcceptableConditionValue === null || this.state.gradeAcceptableConditionValue === "")
                    || (this.state.gradeMajorIssuesConditionValue === null || this.state.gradeMajorIssuesConditionValue === "")
                    || (this.state.tireAdjustmentBelowThresholdAmount === null || this.state.tireAdjustmentBelowThresholdAmount === "")
                    || (this.state.tireAdjustmentAboveThresholdAmount === null || this.state.tireAdjustmentAboveThresholdAmount === "")
                    || (this.state.tireAdjustmentThreshold === null || this.state.tireAdjustmentThreshold === "")
                    || (this.state.windshieldAdjustmentBelowThresholdAmount === null || this.state.windshieldAdjustmentBelowThresholdAmount === "")
                    || (this.state.windshieldAdjustmentAboveThresholdAmount === null || this.state.windshieldAdjustmentAboveThresholdAmount === "")
                    || (this.state.windshieldAdjustmentThreshold === null || this.state.windshieldAdjustmentThreshold === "")
                    || (this.state.generalAdjustmentValue === null || this.state.generalAdjustmentValue === "")
                    || (this.state.wholesaleAdjustmentValue === null || this.state.wholesaleAdjustmentValue === "")
                    || (this.state.accidentAdjustmentValue === null || this.state.accidentAdjustmentValue === ""));
            if (!disabled) {
                disabled = !(
                    (this.state.selectedYear && this.state.selectedMake && this.state.selectedModel)
                    || (this.state.selectedYear && this.state.selectedMake && !this.state.selectedModel)
                    || (!this.state.selectedYear && this.state.selectedMake && this.state.selectedModel)
                    || (!this.state.selectedYear && this.state.selectedMake && !this.state.selectedModel)
                    || (this.state.selectedYear && !this.state.selectedMake && !this.state.selectedModel)
                );
            }

            this.setState({ saveDisabled: disabled });
        }
        catch (error) {
            console.logError(error, "TenantSiteOfferMMRCalculationEditComponent", "onDisableSave");
        }
    }

    onYearClick(id, year) {
        try {
            this.setState({
                selectedYear: year,
                models: null,
                selectedModel: null
            }, () => {
                this.onDisableSave();
                if (this.state.selectedMake !== null) {
                    this.getMMRVehicleModels();
                }
            });
        }
        catch (error) {
            console.logError(error, "TenantSiteOfferMMRCalculationEditComponent", "onYearClick", id);
        }
    }

    onMakeClick(id, make) {
        try {
            this.setState({
                selectedMake: make,
                models: null,
                selectedModel: null
            }, () => {
                this.onDisableSave();
                this.getMMRVehicleModels();
            });

        }
        catch (error) {
            console.logError(error, "TenantSiteOfferMMRCalculationEditComponent", "onMakeClick", id);
        }
    }

    onModelClick(id, model) {
        try {
            this.setState({
                selectedModel: model
            }, () => {
                this.onDisableSave();
            });
        }
        catch (error) {
            console.logError(error, "TenantSiteOfferMMRCalculationEditComponent", "onModelClick", id);
        }
    }

    onConfirmationOkClick(event) {
        try {
            this.setState({
                id: null,
                saveDisabled: false,
                showUpdateConfirmation: false
            });
        }
        catch (error) {
            console.logError(error, "TenantSiteOfferMMRCalculationEditComponent", "onConfirmationOkClick");
        }
    }

    render() {
        let legendText = <div className="text-nowrap d-inline">
            <div className="d-inline admin-legend admin-site-config-differ-bg" />&nbsp;&nbsp;&nbsp;Changed
        </div>;
        let modalTitle = "MMR Offer Configuration";
        if (this.props.rowData && this.props.rowData?.length > 0) {
            let extendedTitle = (this.state.selectedYear ?? "")
                + (this.state.selectedMake && this.state.selectedMake.makeName ? " " + this.state.selectedMake.makeName : "")
                + (this.state.selectedModel && this.state.selectedModel.modelName ? " " + this.state.selectedModel.modelName : "");

            if (extendedTitle !== "")
                modalTitle += " - " + extendedTitle;
        }

        return <SellToWebAdminModalDialogComponent
            showDialog={this.props.showDialog}
            className="admin-site-config-dialog"
            title={modalTitle}
            onCancelClick={this.onCancelClick}
            legendText={(this.props.rowData?.length > 1) ? legendText : null}
        >
            <SellToWebModalDialogHeaderButtonComponent>
                {
                    this.props.rowData?.length === 1
                        ? <button className="btn btn-primary admin-icon " onClick={this.onSaveAsClick} disabled={this.state.enableYMM}>
                            Save As <i className="fas fa-save admin-icon" />
                        </button>
                        : null
                }
                <button className="btn btn-primary admin-icon " onClick={this.onSaveClick} disabled={this.state.saveDisabled}>
                    Save <i className="fas fa-save admin-icon" />
                </button>
            </SellToWebModalDialogHeaderButtonComponent>
            <div className="admin-body">
                <SellToWebModalConfirmationComponent
                    headerText="MMR Configurations"
                    bodyText={"This " + (this.state.selectedMake?.makeName ?? "") + " " + (this.state.selectedYear ? CommonService.formatYear(this.state.selectedYear) : "") + " " + (this.state.selectedModel?.modelName ?? "") + " already exists.  Click the edit icon to make changes."}
                    showConfirmation={this.state.showUpdateConfirmation}
                    onOkClick={this.onConfirmationOkClick}
                    className="admin-global-user-edit-modal" />

                <div className="card">
                    <div className="card-block">
                        <div className="row">
                            <SellToWebAdminDropdownComponent label="Make" data={this.state.makes} disabled={!this.state.enableYMM} itemKey="makeName" onItemClick={this.onMakeClick} value={this.state.selectedMake ? this.state.selectedMake.makeName : ""} colSpan="col-4" />
                            <SellToWebAdminDropdownComponent label="Year" data={this.state.years} disabled={!this.state.enableYMM} displayFormat="Year" onItemClick={this.onYearClick} value={this.state.selectedYear} colSpan="col-4" />
                            <SellToWebAdminDropdownComponent label="Model" data={this.state.models} disabled={!this.state.enableYMM} itemKey="modelName" onItemClick={this.onModelClick} value={this.state.selectedModel ? this.state.selectedModel.modelName : ""} colSpan="col-4" inputCssName="admin-site-config-dialog-input" />
                        </div>
                        <div className="row">
                            <SellToWebAdminInputComponent id="maximumOfferAmount" label="Maximum Offer" disabled={!this.state.isDefault && this.state.maximumOfferAmountEnabled} inputType="money" colSpan="col-8" labelSpan="col-7" controlSpan="col-5"
                                onChange={this.onTextChange} value={this.state.maximumOfferAmountEnabled ? this.props.defaultRow.maximumOfferAmount : this.state.maximumOfferAmount}
                                inputClassName={(this.props.rowData?.length > 1 && (this.state.maximumOfferAmountEnabled || this.state.maximumOfferAmount !== "")) ? "admin-site-config-differ-bg" : ""} />
                            {
                                !this.state.isDefault
                                    ? <SellToWebAdminToggleComponent id="maximumOfferAmountEnabled" colSpan="col-4"
                                        onChange={this.onCheckboxChange} value={this.state.maximumOfferAmountEnabled}
                                        label="Same as Default" label2={this.props.defaultRow ? CommonService.formatCurrency(this.props.defaultRow.maximumOfferAmount) : ""} />
                                    : null
                            }
                        </div>
                        <div className="row">
                            <SellToWebAdminInputComponent id="maximumOdometer" label="Maximum Odometer" disabled={!this.state.isDefault && this.state.maximumOdometerEnabled} inputType="number" colSpan="col-8" labelSpan="col-7" controlSpan="col-5"
                                onChange={this.onTextChange} value={this.state.maximumOdometerEnabled ? this.props.defaultRow.maximumOdometer : this.state.maximumOdometer}
                                inputClassName={(this.props.rowData?.length > 1 && (this.state.maximumOdometerEnabled || this.state.maximumOdometer !== "")) ? "admin-site-config-differ-bg" : ""} />
                            {
                                !this.state.isDefault
                                    ? <SellToWebAdminToggleComponent id="maximumOdometerEnabled" colSpan="col-4"
                                        onChange={this.onCheckboxChange} value={this.state.maximumOdometerEnabled}
                                        label="Same as Default" label2={this.props.defaultRow ? CommonService.formatNumber(this.props.defaultRow.maximumOdometer) : ""} />
                                    : null
                            }
                        </div>
                        <div className="row">
                            <SellToWebAdminInputComponent id="minimumYear" label="Minimum Year" disabled={!this.state.isDefault && this.state.minimumYearEnabled} inputType="number" colSpan="col-8" labelSpan="col-7" controlSpan="col-5"
                                onChange={this.onTextChange} value={this.state.minimumYearEnabled ? this.props.defaultRow.minimumYear : this.state.minimumYear}
                                inputClassName={(this.props.rowData?.length > 1 && (this.state.minimumYearEnabled || this.state.minimumYear !== "")) ? "admin-site-config-differ-bg" : ""} />
                            {
                                !this.state.isDefault
                                    ? <SellToWebAdminToggleComponent id="minimumYearEnabled" colSpan="col-4"
                                        onChange={this.onCheckboxChange} value={this.state.minimumYearEnabled}
                                        label="Same as Default" label2={this.props.defaultRow ? Math.round(this.props.defaultRow.minimumYear) : ""} />
                                    : null
                            }
                        </div>
                        <div className="row">
                            <SellToWebAdminInputComponent id="minimumAverageGrade" label="Minimum Average Grade" disabled={!this.state.isDefault && this.state.minimumAverageGradeEnabled} inputType="number" colSpan="col-8" labelSpan="col-7" controlSpan="col-5"
                                onChange={this.onTextChange} value={this.state.minimumAverageGradeEnabled ? this.props.defaultRow.minimumAverageGrade : this.state.minimumAverageGrade}
                                inputClassName={(this.props.rowData?.length > 1 && (this.state.minimumAverageGradeEnabled || this.state.minimumAverageGrade !== "")) ? "admin-site-config-differ-bg" : ""} />
                            {
                                !this.state.isDefault
                                    ? <SellToWebAdminToggleComponent id="minimumAverageGradeEnabled" colSpan="col-4"
                                        onChange={this.onCheckboxChange} value={this.state.minimumAverageGradeEnabled}
                                        label="Same as Default" label2={this.props.defaultRow ? CommonService.formatNumber(this.props.defaultRow.minimumAverageGrade) : ""} />
                                    : null
                            }
                        </div>
                        <div className="row">
                            <b className="admin-site-config-dialog-mmr-calculation-label">MMR Condition Grade Values&nbsp;<span>(MMR CR 1.0 = 10, MMR CR 5.0 = 50, etc.)</span></b>
                        </div>
                        <div className="row">
                            <SellToWebAdminInputComponent id="gradeLikeNewConditionValue" label="Like New" disabled={!this.state.isDefault && this.state.gradeLikeNewConditionValueEnabled} inputType="number" colSpan="col-8" labelSpan="col-7" controlSpan="col-5" labelClassName="admin-site-config-dialog-mmr-calculation-label"
                                onChange={this.onTextChange} value={this.state.gradeLikeNewConditionValueEnabled ? this.props.defaultRow.gradeLikeNewConditionValue : this.state.gradeLikeNewConditionValue}
                                inputClassName={(this.props.rowData?.length > 1 && (this.state.gradeLikeNewConditionValueEnabled || this.state.gradeLikeNewConditionValue !== "")) ? "admin-site-config-differ-bg" : ""} />
                            {
                                !this.state.isDefault
                                    ? <SellToWebAdminToggleComponent id="gradeLikeNewConditionValueEnabled" colSpan="col-4"
                                        onChange={this.onCheckboxChange} value={this.state.gradeLikeNewConditionValueEnabled}
                                        label="Same as Default" label2={this.props.defaultRow ? CommonService.formatNumber(this.props.defaultRow.gradeLikeNewConditionValue) : ""} />
                                    : null
                            }
                        </div>
                        <div className="row">
                            <SellToWebAdminInputComponent id="gradeVeryGoodConditionValue" label="Very Good" disabled={!this.state.isDefault && this.state.gradeVeryGoodConditionValueEnabled} inputType="number" colSpan="col-8" labelSpan="col-7" controlSpan="col-5" labelClassName="admin-site-config-dialog-mmr-calculation-label"
                                onChange={this.onTextChange} value={this.state.gradeVeryGoodConditionValueEnabled ? this.props.defaultRow.gradeVeryGoodConditionValue : this.state.gradeVeryGoodConditionValue}
                                inputClassName={(this.props.rowData?.length > 1 && (this.state.gradeVeryGoodConditionValueEnabled || this.state.gradeVeryGoodConditionValue !== "")) ? "admin-site-config-differ-bg" : ""} />
                            {
                                !this.state.isDefault
                                    ? <SellToWebAdminToggleComponent id="gradeVeryGoodConditionValueEnabled" colSpan="col-4"
                                        onChange={this.onCheckboxChange} value={this.state.gradeVeryGoodConditionValueEnabled}
                                        label="Same as Default" label2={this.props.defaultRow ? CommonService.formatNumber(this.props.defaultRow.gradeVeryGoodConditionValue) : ""} />
                                    : null
                            }
                        </div>
                        <div className="row">
                            <SellToWebAdminInputComponent id="gradeAcceptableConditionValue" label="Acceptable" disabled={!this.state.isDefault && this.state.gradeAcceptableConditionValueEnabled} inputType="number" colSpan="col-8" labelSpan="col-7" controlSpan="col-5" labelClassName="admin-site-config-dialog-mmr-calculation-label"
                                onChange={this.onTextChange} value={this.state.gradeAcceptableConditionValueEnabled ? this.props.defaultRow.gradeAcceptableConditionValue : this.state.gradeAcceptableConditionValue}
                                inputClassName={(this.props.rowData?.length > 1 && (this.state.gradeAcceptableConditionValueEnabled || this.state.gradeAcceptableConditionValue !== "")) ? "admin-site-config-differ-bg" : ""} />
                            {
                                !this.state.isDefault
                                    ? <SellToWebAdminToggleComponent id="gradeAcceptableConditionValueEnabled" colSpan="col-4"
                                        onChange={this.onCheckboxChange} value={this.state.gradeAcceptableConditionValueEnabled}
                                        label="Same as Default" label2={this.props.defaultRow ? CommonService.formatNumber(this.props.defaultRow.gradeAcceptableConditionValue) : ""} />
                                    : null
                            }
                        </div>
                        <div className="row">
                            <SellToWebAdminInputComponent id="gradeMajorIssuesConditionValue" label="Major Issues" disabled={!this.state.isDefault && this.state.gradeMajorIssuesConditionValueEnabled} inputType="number" colSpan="col-8" labelSpan="col-7" controlSpan="col-5" labelClassName="admin-site-config-dialog-mmr-calculation-label"
                                onChange={this.onTextChange} value={this.state.gradeMajorIssuesConditionValueEnabled ? this.props.defaultRow.gradeMajorIssuesConditionValue : this.state.gradeMajorIssuesConditionValue}
                                inputClassName={(this.props.rowData?.length > 1 && (this.state.gradeMajorIssuesConditionValueEnabled || this.state.gradeMajorIssuesConditionValue !== "")) ? "admin-site-config-differ-bg" : ""} />
                            {
                                !this.state.isDefault
                                    ? <SellToWebAdminToggleComponent id="gradeMajorIssuesConditionValueEnabled" colSpan="col-4"
                                        onChange={this.onCheckboxChange} value={this.state.gradeMajorIssuesConditionValueEnabled}
                                        label="Same as Default" label2={this.props.defaultRow ? CommonService.formatNumber(this.props.defaultRow.gradeMajorIssuesConditionValue) : ""} />
                                    : null
                            }
                        </div>
                        <div className="row">
                            <b className="admin-site-config-dialog-mmr-calculation-label">Tire Adjustment</b>
                        </div>
                        <div className="row">
                            <SellToWebAdminInputComponent id="tireAdjustmentThreshold" label="If MMR is above or below" disabled={!this.state.isDefault && this.state.tireAdjustmentThresholdEnabled} inputType="money" colSpan="col-8" labelSpan="col-7" controlSpan="col-5" labelClassName="admin-site-config-dialog-mmr-calculation-label"
                                onChange={this.onTextChange} value={this.state.tireAdjustmentThresholdEnabled ? this.props.defaultRow.tireAdjustmentThreshold : this.state.tireAdjustmentThreshold}
                                inputClassName={(this.props.rowData?.length > 1 && (this.state.tireAdjustmentThresholdEnabled || this.state.tireAdjustmentThreshold !== "")) ? "admin-site-config-differ-bg" : ""} />
                            {
                                !this.state.isDefault
                                    ? <SellToWebAdminToggleComponent id="tireAdjustmentThresholdEnabled" colSpan="col-4"
                                        onChange={this.onCheckboxChange} value={this.state.tireAdjustmentThresholdEnabled}
                                        label="Same as Default" label2={this.props.defaultRow ? CommonService.formatCurrency(this.props.defaultRow.tireAdjustmentThreshold) : ""} />
                                    : null
                            }
                        </div>
                        <div className="row">
                            <b className="admin-site-config-dialog-mmr-calculation-child-label">Tire Deduction</b>
                        </div>
                        <div className="row">
                            <SellToWebAdminInputComponent id="tireAdjustmentBelowThresholdAmount" label="Below Specified MMR" disabled={!this.state.isDefault && this.state.tireAdjustmentBelowThresholdAmountEnabled} inputType="money" colSpan="col-8" labelSpan="col-7" controlSpan="col-5" labelClassName="admin-site-config-dialog-mmr-calculation-child-label"
                                onChange={this.onTextChange} value={this.state.tireAdjustmentBelowThresholdAmountEnabled ? this.props.defaultRow.tireAdjustmentBelowThresholdAmount : this.state.tireAdjustmentBelowThresholdAmount}
                                inputClassName={(this.props.rowData?.length > 1 && (this.state.tireAdjustmentBelowThresholdAmountEnabled || this.state.tireAdjustmentBelowThresholdAmount !== "")) ? "admin-site-config-differ-bg" : ""} />
                            {
                                !this.state.isDefault
                                    ? <SellToWebAdminToggleComponent id="tireAdjustmentBelowThresholdAmountEnabled" colSpan="col-4"
                                        onChange={this.onCheckboxChange} value={this.state.tireAdjustmentBelowThresholdAmountEnabled}
                                        label="Same as Default" label2={this.props.defaultRow ? CommonService.formatCurrency(this.props.defaultRow.tireAdjustmentBelowThresholdAmount) : ""} />
                                    : null
                            }
                        </div>
                        <div className="row">
                            <SellToWebAdminInputComponent id="tireAdjustmentAboveThresholdAmount" label="Above Specified MMR" disabled={!this.state.isDefault && this.state.tireAdjustmentAboveThresholdAmountEnabled} inputType="money" colSpan="col-8" labelSpan="col-7" controlSpan="col-5" labelClassName="admin-site-config-dialog-mmr-calculation-child-label"
                                onChange={this.onTextChange} value={this.state.tireAdjustmentAboveThresholdAmountEnabled ? this.props.defaultRow.tireAdjustmentAboveThresholdAmount : this.state.tireAdjustmentAboveThresholdAmount}
                                inputClassName={(this.props.rowData?.length > 1 && (this.state.tireAdjustmentAboveThresholdAmountEnabled || this.state.tireAdjustmentAboveThresholdAmount !== "")) ? "admin-site-config-differ-bg" : ""} />
                            {
                                !this.state.isDefault
                                    ? <SellToWebAdminToggleComponent id="tireAdjustmentAboveThresholdAmountEnabled" colSpan="col-4"
                                        onChange={this.onCheckboxChange} value={this.state.tireAdjustmentAboveThresholdAmountEnabled}
                                        label="Same as Default" label2={this.props.defaultRow ? CommonService.formatCurrency(this.props.defaultRow.tireAdjustmentAboveThresholdAmount) : ""} />
                                    : null
                            }
                        </div>
                        <div className="row">
                            <b className="admin-site-config-dialog-mmr-calculation-label">Windshield Adjustment</b>
                        </div>
                        <div className="row">
                            <SellToWebAdminInputComponent id="windshieldAdjustmentThreshold" label="If MMR is above or below" disabled={!this.state.isDefault && this.state.windshieldAdjustmentThresholdEnabled} inputType="money" colSpan="col-8" labelSpan="col-7" controlSpan="col-5" labelClassName="admin-site-config-dialog-mmr-calculation-label"
                                onChange={this.onTextChange} value={this.state.windshieldAdjustmentThresholdEnabled ? this.props.defaultRow.windshieldAdjustmentThreshold : this.state.windshieldAdjustmentThreshold}
                                inputClassName={(this.props.rowData?.length > 1 && (this.state.windshieldAdjustmentThresholdEnabled || this.state.windshieldAdjustmentThreshold !== "")) ? "admin-site-config-differ-bg" : ""} />
                            {
                                !this.state.isDefault
                                    ? <SellToWebAdminToggleComponent id="windshieldAdjustmentThresholdEnabled" colSpan="col-4"
                                        onChange={this.onCheckboxChange} value={this.state.windshieldAdjustmentThresholdEnabled}
                                        label="Same as Default" label2={this.props.defaultRow ? CommonService.formatCurrency(this.props.defaultRow.windshieldAdjustmentThreshold) : ""} />
                                    : null
                            }
                        </div>
                        <div className="row">
                            <b className="admin-site-config-dialog-mmr-calculation-child-label">Windshield Deduction</b>
                        </div>
                        <div className="row">
                            <SellToWebAdminInputComponent id="windshieldAdjustmentBelowThresholdAmount" label="Below Specified MMR" disabled={!this.state.isDefault && this.state.windshieldAdjustmentBelowThresholdAmountEnabled} inputType="money" colSpan="col-8" labelSpan="col-7" controlSpan="col-5" labelClassName="admin-site-config-dialog-mmr-calculation-child-label"
                                onChange={this.onTextChange} value={this.state.windshieldAdjustmentBelowThresholdAmountEnabled ? this.props.defaultRow.windshieldAdjustmentBelowThresholdAmount : this.state.windshieldAdjustmentBelowThresholdAmount}
                                inputClassName={(this.props.rowData?.length > 1 && (this.state.windshieldAdjustmentBelowThresholdAmountEnabled || this.state.windshieldAdjustmentBelowThresholdAmount !== "")) ? "admin-site-config-differ-bg" : ""} />
                            {
                                !this.state.isDefault
                                    ? <SellToWebAdminToggleComponent id="windshieldAdjustmentBelowThresholdAmountEnabled" colSpan="col-4"
                                        onChange={this.onCheckboxChange} value={this.state.windshieldAdjustmentBelowThresholdAmountEnabled}
                                        label="Same as Default" label2={this.props.defaultRow ? CommonService.formatCurrency(this.props.defaultRow.windshieldAdjustmentBelowThresholdAmount) : ""} />
                                    : null
                            }
                        </div>
                        <div className="row">
                            <SellToWebAdminInputComponent id="windshieldAdjustmentAboveThresholdAmount" label="Above Specified MMR" disabled={!this.state.isDefault && this.state.windshieldAdjustmentAboveThresholdAmountEnabled} inputType="money" colSpan="col-8" labelSpan="col-7" controlSpan="col-5" labelClassName="admin-site-config-dialog-mmr-calculation-child-label"
                                onChange={this.onTextChange} value={this.state.windshieldAdjustmentAboveThresholdAmountEnabled ? this.props.defaultRow.windshieldAdjustmentAboveThresholdAmount : this.state.windshieldAdjustmentAboveThresholdAmount}
                                inputClassName={(this.props.rowData?.length > 1 && (this.state.windshieldAdjustmentAboveThresholdAmountEnabled || this.state.windshieldAdjustmentAboveThresholdAmount !== "")) ? "admin-site-config-differ-bg" : ""} />
                            {
                                !this.state.isDefault
                                    ? <SellToWebAdminToggleComponent id="windshieldAdjustmentAboveThresholdAmountEnabled" colSpan="col-4"
                                        onChange={this.onCheckboxChange} value={this.state.windshieldAdjustmentAboveThresholdAmountEnabled}
                                        label="Same as Default" label2={this.props.defaultRow ? CommonService.formatCurrency(this.props.defaultRow.windshieldAdjustmentAboveThresholdAmount) : ""} />
                                    : null
                            }
                        </div>
                        <div className="row">
                            <div className="col-8">
                                <div className="row">
                                    <SellToWebAdminToggleComponent id="generalAdjustmentIsDollar" onChange={this.onCheckboxChange} colSpan="col-7"
                                        value={this.state.generalAdjustmentValueEnabled ? this.props.defaultRow.generalAdjustmentIsDollar : this.state.generalAdjustmentIsDollar}
                                        label="General Adjustment:&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Percent" label2="Dollar" />
                                    <SellToWebAdminInputComponent id="generalAdjustmentValue" placeholder="General Adjustment" disabled={!this.state.isDefault && this.state.generalAdjustmentValueEnabled} colSpan="col-5" controlSpan="col-12" className="admin-site-config-dialog-mmr-calculation-control-padding"
                                        inputType={this.state.generalAdjustmentValueEnabled ? (this.props.defaultRow.generalAdjustmentIsDollar ? "money" : "percent") : (this.state.generalAdjustmentIsDollar ? "money" : "percent")}
                                        onChange={this.onTextChange} value={this.state.generalAdjustmentValueEnabled ? (this.props.defaultRow.generalAdjustmentIsDollar ? this.props.defaultRow.generalAdjustmentValue : this.props.defaultRow.generalAdjustmentValue * 100) : (this.state.generalAdjustmentIsDollar ? this.state.generalAdjustmentValue : this.state.generalAdjustmentValue)}
                                        inputClassName={(this.props.rowData?.length > 1 && (this.state.generalAdjustmentValueEnabled || (this.state.generalAdjustmentValue && this.state.generalAdjustmentValue !== ""))) ? "admin-site-config-differ-bg" : ""} />
                                </div>
                            </div>
                            {
                                !this.state.isDefault
                                    ? <SellToWebAdminToggleComponent id="generalAdjustmentValueEnabled" colSpan="col-4"
                                        onChange={this.onCheckboxChange} value={this.state.generalAdjustmentValueEnabled}
                                        label="Same as Default" label2={this.props.defaultRow ? (this.props.defaultRow.generalAdjustmentIsDollar ? CommonService.formatCurrency(this.props.defaultRow.generalAdjustmentValue) : CommonService.formatPercentage_1(this.props.defaultRow.generalAdjustmentValue)) : ""} />
                                    : null
                            }
                        </div>
                        <div className="row">
                            <div className="col-8">
                                <div className="row">
                                    <SellToWebAdminToggleComponent id="accidentAdjustmentIsDollar" onChange={this.onCheckboxChange} colSpan="col-7"
                                        value={this.state.accidentAdjustmentValueEnabled ? this.props.defaultRow.accidentAdjustmentIsDollar : this.state.accidentAdjustmentIsDollar}
                                        label="Accident Adjustment:&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Percent" label2="Dollar" />
                                    <SellToWebAdminInputComponent id="accidentAdjustmentValue" placeholder="Accident Adjustment" disabled={!this.state.isDefault && this.state.accidentAdjustmentValueEnabled} colSpan="col-5" controlSpan="col-12" className="admin-site-config-dialog-mmr-calculation-control-padding"
                                        inputType={this.state.accidentAdjustmentValueEnabled ? (this.props.defaultRow.accidentAdjustmentIsDollar ? "money" : "percent") : (this.state.accidentAdjustmentIsDollar ? "money" : "percent")}
                                        onChange={this.onTextChange} value={this.state.accidentAdjustmentValueEnabled ? (this.props.defaultRow.accidentAdjustmentIsDollar ? this.props.defaultRow.accidentAdjustmentValue : this.props.defaultRow.accidentAdjustmentValue * 100) : (this.state.accidentAdjustmentIsDollar ? this.state.accidentAdjustmentValue : this.state.accidentAdjustmentValue)}
                                        inputClassName={(this.props.rowData?.length > 1 && (this.state.accidentAdjustmentValueEnabled || (this.state.accidentAdjustmentValue && this.state.accidentAdjustmentValue !== ""))) ? "admin-site-config-differ-bg" : ""} />
                                </div>
                            </div>
                            {
                                !this.state.isDefault
                                    ? <SellToWebAdminToggleComponent id="accidentAdjustmentValueEnabled" colSpan="col-4"
                                        onChange={this.onCheckboxChange} value={this.state.accidentAdjustmentValueEnabled}
                                        label="Same as Default" label2={this.props.defaultRow ? (this.props.defaultRow.accidentAdjustmentIsDollar ? CommonService.formatCurrency(this.props.defaultRow.accidentAdjustmentValue) : CommonService.formatPercentage_1(this.props.defaultRow.accidentAdjustmentValue)) : ""} />
                                    : null
                            }
                        </div>
                        <div className="row">
                            <div className="col-8">
                                <div className="row">
                                    <SellToWebAdminToggleComponent id="wholesaleAdjustmentIsDollar" onChange={this.onCheckboxChange} colSpan="col-7"
                                        value={this.state.wholesaleAdjustmentValueEnabled ? this.props.defaultRow.wholesaleAdjustmentIsDollar : this.state.wholesaleAdjustmentIsDollar}
                                        label="Wholesale Adjustment:&nbsp;&nbsp;&nbsp;&nbsp;Percent" label2="Dollar" />
                                    <SellToWebAdminInputComponent id="wholesaleAdjustmentValue" placeholder="Wholesale Adjustment" disabled={!this.state.isDefault && this.state.wholesaleAdjustmentValueEnabled} colSpan="col-5" controlSpan="col-12" className="admin-site-config-dialog-mmr-calculation-control-padding"
                                        inputType={this.state.wholesaleAdjustmentValueEnabled ? (this.props.defaultRow.wholesaleAdjustmentIsDollar ? "money" : "percent") : (this.state.wholesaleAdjustmentIsDollar ? "money" : "percent")}
                                        onChange={this.onTextChange} value={this.state.wholesaleAdjustmentValueEnabled ? (this.props.defaultRow.wholesaleAdjustmentIsDollar ? this.props.defaultRow.wholesaleAdjustmentValue : this.props.defaultRow.wholesaleAdjustmentValue * 100) : (this.state.wholesaleAdjustmentIsDollar ? this.state.wholesaleAdjustmentValue : this.state.wholesaleAdjustmentValue)}
                                        inputClassName={(this.props.rowData?.length > 1 && (this.state.wholesaleAdjustmentValueEnabled || (this.state.wholesaleAdjustmentValue && this.state.wholesaleAdjustmentValue !== ""))) ? "admin-site-config-differ-bg" : ""} />
                                </div>
                            </div>
                            {
                                !this.state.isDefault
                                    ? <SellToWebAdminToggleComponent id="wholesaleAdjustmentValueEnabled" colSpan="col-4"
                                        onChange={this.onCheckboxChange} value={this.state.wholesaleAdjustmentValueEnabled}
                                        label="Same as Default" label2={this.props.defaultRow ? (this.props.defaultRow.wholesaleAdjustmentIsDollar ? CommonService.formatCurrency(this.props.defaultRow.wholesaleAdjustmentValue) : CommonService.formatPercentage_1(this.props.defaultRow.wholesaleAdjustmentValue)) : ""} />
                                    : null
                            }
                        </div>
                        <div className="row">
                            <div className="admin-control col-8">
                                <div className="input-group">
                                    <div className="col-7 admin-label">Odometer Adjustment:</div>
                                    <div className="col-5">
                                        <SellToWebAdminToggleComponent id="odometerAdjustmentEnabled" disabled={!this.state.isDefault && this.state.odometerAdjustmentEnabledEnabled} colSpan="col-9"
                                            onChange={this.onCheckboxChange} value={this.state.odometerAdjustmentEnabledEnabled ? this.props.defaultRow.odometerAdjustmentEnabled : this.state.odometerAdjustmentEnabled}
                                            label="No" label2="Yes" />
                                    </div>
                                </div>
                            </div>
                            {
                                !this.state.isDefault
                                    ? <SellToWebAdminToggleComponent id="odometerAdjustmentEnabledEnabled" colSpan="col-4"
                                        onChange={this.onCheckboxChange} value={this.state.odometerAdjustmentEnabledEnabled}
                                        label="Same as Default" label2={this.props.defaultRow ? (this.props.defaultRow.odometerAdjustmentEnabled ? "Yes" : "No") : ""} />
                                    : null
                            }
                        </div>
                        <div className="row">
                            <div className="admin-control col-8">
                                <div className="input-group">
                                    <div className="col-7 admin-label">Forecast Adjustment:</div>
                                    <div className="col-5">
                                        <SellToWebAdminToggleComponent id="forecastAdjustmentEnabled" disabled={!this.state.isDefault && this.state.forecastAdjustmentEnabledEnabled} colSpan="col-9"
                                            onChange={this.onCheckboxChange} value={this.state.forecastAdjustmentEnabledEnabled ? this.props.defaultRow.forecastAdjustmentEnabled : this.state.forecastAdjustmentEnabled}
                                            label="No" label2="Yes" />
                                    </div>
                                </div>
                            </div>
                            {
                                !this.state.isDefault
                                    ? <SellToWebAdminToggleComponent id="forecastAdjustmentEnabledEnabled" colSpan="col-4"
                                        onChange={this.onCheckboxChange} value={this.state.forecastAdjustmentEnabledEnabled}
                                        label="Same as Default" label2={this.props.defaultRow ? (this.props.defaultRow.forecastAdjustmentEnabled ? "Yes" : "No") : ""} />
                                    : null
                            }
                        </div>
                        <div className="row">
                            <div className="admin-control col-8">
                                <div className="input-group">
                                    <div className="col-7 admin-label">Enable Offer Calculation:</div>
                                    <div className="col-5">
                                        <SellToWebAdminToggleComponent id="enableOfferCalculation" disabled={!this.state.isDefault && this.state.enableYMM} colSpan="col-9"
                                            onChange={this.onCheckboxChange} value={this.state.enableOfferCalculation}
                                            label="No" label2="Yes" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </SellToWebAdminModalDialogComponent>;
    }
}
